import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { setDevice } from "../store/preview";
import { ROOT_ID } from "../utils/constants";

export function usePreview() {
  const dispatch = useDispatch();
  const previewState = useSelector((state: RootState) => state.preview);

  useEffect(() => {
    const rootElement = document.getElementById(ROOT_ID);
    if (rootElement) {
      const { preview } = rootElement.dataset;
      if (preview) {
        dispatch(setDevice(preview));
      }
    }
  }, [dispatch]);

  return {
    isPreview: !!previewState.device,
    device: previewState.device,
  };
}
